import "./Modal.scss";
import "./AddDestinationModal.scss";
import { useEffect } from "react";

function AddDestinationModal({
  destinationModalOpen,
  newDestName,
  newDestSlotBased,
  boatDestinationModal,
  selectedDestIds,
  allGlobalDestinations,
  setNewDestName,
  setNewDestSlotBased,
  setBoatDestinationModal,
  setSelectedDestIds,
  onCloseDestModal,
  onCloseBoatDestModal,
  onCreateDestination,
  onToggleBoatDestination,
  onSaveBoatDestinations,
}) {
  useEffect(() => {
    const isAnyModalOpen = destinationModalOpen || boatDestinationModal;
    if (isAnyModalOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [destinationModalOpen, boatDestinationModal]);

  return (
    <>
      {/* ── Add Destination Modal ── */}
      {destinationModalOpen && (
        <div
          className="popup-overlay-admin"
          onClick={(e) =>
            e.target.classList.contains("popup-overlay-admin") &&
            onCloseDestModal()
          }
        >
          <div className="popup-content">
            <button className="close-button" onClick={onCloseDestModal}>
              &times;
            </button>
            <h1>Add New Destination</h1>
            <div className="edit-info">
              <label>
                Destination Name
                <input
                  value={newDestName}
                  onChange={(e) => setNewDestName(e.target.value)}
                  placeholder="e.g. Paradise Bay"
                />
              </label>
              <label>
                Type
                <select
                  value={newDestSlotBased ? "slot" : "fullday"}
                  onChange={(e) => setNewDestSlotBased(e.target.value === "slot")}
                >
                  <option value="slot">Slot-based (3 pricing tiers)</option>
                  <option value="fullday">Full-day only (with drop-off option)</option>
                </select>
              </label>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={onCloseDestModal}>
                Cancel
              </button>
              <button className="save-btn" onClick={onCreateDestination}>
                Add Destination
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Boat Destination Assignment Modal ── */}
      {boatDestinationModal && (
        <div
          className="popup-overlay-admin"
          onClick={(e) =>
            e.target.classList.contains("popup-overlay-admin") &&
            onCloseBoatDestModal()
          }
        >
          <div className="popup-content">
            <button className="close-button" onClick={onCloseBoatDestModal}>
              &times;
            </button>
            <h1>Manage Destinations for {boatDestinationModal.name}</h1>
            <div className="checkbox-list">
              {allGlobalDestinations &&
                allGlobalDestinations.map((dest) => (
                  <label key={dest._id}>
                    <input
                      type="checkbox"
                      checked={selectedDestIds.includes(dest._id)}
                      onChange={() => onToggleBoatDestination(dest._id)}
                    />
                    {dest.name}
                  </label>
                ))}
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={onCloseBoatDestModal}>
                Cancel
              </button>
              <button className="save-btn" onClick={onSaveBoatDestinations}>
                Save Destinations
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddDestinationModal;
